import React, {useState} from "react";
import * as styles from "./AccordionContent.module.scss";
import FeaturedCard from "./FeaturedCard/FeaturedCard";
import ventilador from "../../../images/venti_abierto.png";
import ventiladorCerrado from "../../../images/venti_cerrado.png";
import cafereta from "../../../images/cafetera2.png";
import arrowBlack from "../../../icons/arrows/downArrowBlack.svg";
import FeaturedTermo from "./FeaturedTermo/FeaturedTermo";
import termo1 from "../../../images/1.png";
import termo2 from "../../../images/2.png";
import termo3 from "../../../images/3.png";
import freidora from "../../../images/nav-productosDest/freidora-inox.png";
import FeaturedVentilador from "./FeaturedVentilador/FeaturedVentilador";
import { Link } from "gatsby";

const AccordionContent = ({ isOpen, patternCategory, childCategory, toggleDropdown }) => {
  const [isOpenSubCat, setIsOpenSubCat] = useState({});

  const mapArrayReplaceSpaces = (value) => {
    if (Array.isArray(value)) {
      return value.map((element) => element.replace(/ /g, "-").toLowerCase());
    } else if (typeof value === "string") {
      return value.replace(/ /g, "-").toLowerCase();
    }
    return value;
  };

  const categoryOrder = ['4', '2', '1', '3']; // Climatización, Cocina, Hogar, Desayuno

  const sortedCategories = [...(patternCategory || [])].sort((a, b) => {
    return categoryOrder.indexOf(String(a.id)) - categoryOrder.indexOf(String(b.id));
  });  

  return (
    <section className={`${styles.container} ${isOpen ? styles.open : ""} section`}>
      <div className={styles.container__section}>
        <div className={styles.center__cotents}>
          <div className={styles.categories_container}>
            <div>
              <p className={styles.title}>Categorías</p>
            </div>
            <div className={styles.categories_list}>
              {sortedCategories.map((category) => {
                const sortedSubCategories = childCategory
                  ?.filter((subCategory) => subCategory.patternCategory === category.id)
                  ?.sort((a, b) => {
                    const aHasChildren = childCategory.some((child) => child.patternCategory === a.id);
                    const bHasChildren = childCategory.some((child) => child.patternCategory === b.id);
                    return bHasChildren - aHasChildren;
                  });

                return (
                  <div key={category.id} className={styles.category__container}>
                    <div className={styles.category_title}>
                      <span className={styles.boldText}>{category.name}</span>
                    </div>

                    <div className={styles.category_dropdown_container}>
                      {sortedSubCategories.map((subCategory) => {
                        const mappedName = mapArrayReplaceSpaces(subCategory.name);
                        const hasChildren = childCategory.some((child) => child.patternCategory === subCategory.id);

                        return hasChildren ? (
                          <div
                            key={subCategory.id}
                            className={styles.subcategory_dropdown}
                            onMouseEnter={(e) => {
                              e.currentTarget.classList.add(styles.open);
                              setIsOpenSubCat((prev) => ({
                                ...prev,
                                [subCategory.id]: true,
                              }));
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.classList.remove(styles.open);
                              setIsOpenSubCat((prev) => ({
                                ...prev,
                                [subCategory.id]: false,
                              }));
                            }}
                          >
                            <div className={styles.subcategory_title}>
                              <span className={styles.boldText}>{subCategory.name}</span>
                              <div
                                className={`${styles.arrowIcon} ${isOpenSubCat[subCategory.id] ? styles.rotateOpen : ""}`}
                              >
                                <img src={arrowBlack} alt="Icono" />
                              </div>
                            </div>
                            <div className={styles.subcategory_container}>
                              {childCategory
                                .filter((child) => child.patternCategory === subCategory.id)
                                .map((child) => (
                                  <Link
                                    to={`/productos/${mapArrayReplaceSpaces(child.name)}`}
                                    key={child.id}
                                    className={styles.texto}
                                    onClick={toggleDropdown}
                                  >
                                    {child.name}
                                  </Link>
                                ))}
                            </div>
                          </div>
                        ) : (
                          <Link
                            to={`/productos/${mappedName}`}
                            key={subCategory.id}
                            className={styles.texto}
                            onClick={toggleDropdown}
                          >
                            {subCategory.name}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.container_destacados}>
            <div>
              <p className={styles.title}>Productos destacados</p>
            </div>
            <div className={styles.container_img}>
              <div className={styles.imageSection}>
                <Link to="/etermo">
                  <FeaturedTermo
                    FirtsImg={termo1}
                    SecondImg={termo2}
                    ThirdImg={termo3}
                    title={"Etermo"}
                  />
                </Link>

                <Link to="/detalle/freidora-de-aire-parrilla-pe-afg03n-ar/">
                  <FeaturedCard
                    FirtsImg={freidora}
                    SecondImg={freidora}
                    title={"Freidora de aire"}
                  />
                </Link>
              </div>
              <div className={styles.imageSection}>
                <Link to="/cafetera">
                  <FeaturedCard
                    FirtsImg={cafereta}
                    SecondImg={cafereta}
                    title={"Cafetera"}
                  />
                </Link>

                <Link to="/ventilador">
                  <FeaturedVentilador
                    FirtsImg={ventilador}
                    SecondImg={ventiladorCerrado}
                    title={"Ventilador Retráctil"}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccordionContent;
